import { MAX_HEIGHT, MAX_PRINT_PAGES, MAX_WIDTH } from "./printing/printControl";

export default {
  // Copy and paste items
  COPY_AND_PASTE_ITEMS_INVALID_COPIED_DATA: "The copied data is invalid",

  // Table View
  TABLE_VIEW_TYPE_TO_CREATE: "Type label to create new ",
  TABLE_VIEW_PASTE_ERROR_WRONG_SIZE: "Pasted data cannot fit in selection range",
  TABLE_VIEW_PASTE_ERROR_MULTIPLE_RANGES: "Paste operation not possible with multiple selection ranges",
  TABLE_VIEW_PASTE_ERROR_INVALID_DATA_TYPE: columnLabel =>
    `Pasted data does not match expected value type for column "${columnLabel}"`,

  TABLE_VIEW_DELETE_ERROR_INVALID_COLUMN: columnLabel => `Data in column "${columnLabel}" cannot be erased`,
  TABLE_VIEW_PASTE_ERROR_DISABLED_COLUMN: columnLabel => `The column "${columnLabel}" is disabled`,

  TABLE_VIEW_CHILDREN_DATES_ARE_OUTSIDE_RANGE: "Item's children extend beyond this date",

  // Printing
  PRINT_ERROR_MAX_PAGES: `Printing is limited to ${MAX_PRINT_PAGES} pages. To reduce the number of pages, lower the scale setting, print selected items only, or return to the timeline and zoom out before printing.`,
  PRINT_ERROR_MAX_SIZE: `Exporting is limited to size ${MAX_WIDTH} X ${MAX_HEIGHT}. To reduce the size, lower the scale setting, export selected items only, or return to the timeline and zoom out before exporting.`,
  PRINT_ERROR_NO_DATA: "The current view has no data to print",
  PRINT_ERROR_GENERIC: "There was an error when attempting to print the data",
  PRINT_ERROR_NOT_IMPLEMENTED: viewType => `The ${viewType} cannot be printed yet`,
  PRINT_WARNING_NO_IMAGES_IN_BROWSER: "Warning: Images will not be printed when testing within the browser",

  // Type changing
  TYPE_CHANGE_CONFIRMATION:
    "Changing this item type will lose existing data that cannot be associated with the new type.\n\nWould you like to continue?",

  // Drag and drop
  DRAG_DROP_DATES_NOT_ALLOWED: "Item type cannot have dates",
  DRAG_DROP_DATE_ORDER_NOT_ALLOWED: "Item type is not allowed in date order",
  DRAG_DROP_NARRATIVE_ORDER_NOT_ALLOWED: "Item type is not allowed in narrative",
  DRAG_DROP_TIMELINE_NOT_ALLOWED: "Cannot be dropped in timeline",
  DRAG_DROP_TIMELINE_DISPLAY_NOT_ALLOWED: "Item type is not shown on timeline",
  DRAG_DROP_TIMELINE_ALREADY_EXISTS: "Item already exists in timeline",
  DRAG_DROP_NO_EFFECT: "Dropping will have no effect",
  DRAG_DROP_MINDMAP_NOT_ALLOWED: "Cannot be dropped in mindmap",
  DRAG_DROP_MINDMAP_ALREADY_EXISTS: "Item already exists in mindmap",
  DRAG_DROP_END_DATE_NOT_ALLOWED: "Item cannot be moved to after its end date",
  DRAG_DROP_LATEST_START_DATE_NOT_ALLOWED: "Item cannot be moved to after its latest start date",
  DRAG_DROP_EARLIEST_END_DATE_NOT_ALLOWED: "Item cannot be moved to after its earliest end date",
  DRAG_DROP_CANNOT_REORDER_DUE_TO_SORT: "Sort by Chronological order (#) to reorder items. You are sorting by ",
  DRAG_DROP_LOCKED_DATES: "Item dates are locked",
  DRAG_DROP_RELATIONSHIP_NOT_ALLOWED: "Item type does not allow relationship",
  DRAG_DROP_START_PAST_END_NOT_ALLOWED: "Cannot move item's start date to after its end date",
  DRAG_DROP_END_BEFORE_START_NOT_ALLOWED: "Cannot move item's end date to before its start date",
  DRAG_DROP_NO_PARENT_TO_GROUP_UNDER: "Need an item to group under",
  DRAG_DROP_GROUP_UNDER_ANCESTOR_NOT_ALLOWED: "Cannot group under existing ancestor",
  DRAG_DROP_GROUP_UNDER_TYPE_NOT_ALLOWED: "Cannot be grouped under item type",
  DRAG_DROP_MEASURE_ACROSS_VIEWS_NOT_ALLOWED: "Cannot measure time difference across views",

  // Import CSV
  IMPORT_CSV_LABEL_COLUMN_MUST_BE_SELECTED: "A column must be selected as the Label for your events",
  IMPORT_CSV_AT_LEAST_ONE_ROW_TO_IMPORT: "There must be at least one row of data to import",
  // Sync
  SYNC_REMOVE_CURRENT_SYNC_TITLE: "Remove Current Sync",
  SYNC_REMOVE_CURRENT_SYNC_MESSAGE:
    "If you remove the current sync, all of your existing sync data will be erased. Are you sure you wish to continue?",

  // Item card details
  APPLY_VIEW_SETTINGS_TO_ALL_VIEWS: "Are you sure you want to update item card view settings for all views?",

  // Footer
  NO_DATE_RANGE: "Infinite Scroll",

  // Murder on the Orient Express warning
  MURDER_ON_THE_ORIENT_EXPRESS: "Murder on the Orient Express",
  AGATHA_CHRISTIE_ACKNOWLEDGEMENT:
    "Material from Murder on the Orient Express by Agatha Christie incorporated under license from Agatha Christie Ltd.",
  AGATHA_CHRISTIE_ACKNOWLEDGEMENT_HEADING: "Licensed Material"
};
